import styled from "styled-components";
import { ProgressBar } from "@8x8/oxygen-loaders";
import Button from "@8x8/oxygen-button";

export const FlexCenteredContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MarginRightSpan = styled.div`
  margin-right: 24px;
`;

export const MarginTopProgressBar = styled(ProgressBar)`
  margin-top: 16px;
`;

export const MarginRightFlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 16px;
  width: 208px;
`;

export const MarginLeftButton = styled(Button)`
  margin-left: 16px;
`;
